import { Modal } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import useInputValue from '../../../../hooks/useInputValue';
import { ButtonGroup } from '../../../generic';
import Button, { BUTTON_SIZE, BUTTON_TYPE, InlineLoaderButton } from '../../../generic/Button';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';

type ModalAddJiraProps = {
  show: boolean;
  isLoading: boolean;
  onHide: () => void;
  onAddJira: (name: string) => Promise<void>;
};

const ModalAddJira: VoidFunctionComponent<ModalAddJiraProps> = ({
  show,
  onHide,
  isLoading,
  onAddJira,
}) => {
  const [newJiraTitle, onNewJiraTitleChange] = useInputValue('');

  const onSave = async () => {
    await onAddJira(newJiraTitle);
    onHide();
  };

  return (
    <Modal
      backdrop="static"
      animation
      show={show}
      onHide={onHide}
      onEscapeKeyDown={onHide}
      className="jira-add-modal"
    >
      <Modal.Header>
        <Modal.Title>
          Add New Jira Site
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LabeledTextInput
          labelVariant="legacy"
          label="Name your jira site"
          onChange={onNewJiraTitleChange}
          value={newJiraTitle}
          placeholder="Jira site 123"
        />
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button
            type={BUTTON_TYPE.SECONDARY}
            size={BUTTON_SIZE.MEDIUM}
            onClick={onHide}
          >
            Cancel
          </Button>
          <InlineLoaderButton
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.MEDIUM}
            isSubmitButton
            isLoading={isLoading}
            onClick={onSave}
          >
            Add
          </InlineLoaderButton>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAddJira;
